import React from 'react';
export function AutoRethreadingSection() {
  return <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-200 space-y-4" data-id="element-4419">
      <h2 className="text-2xl font-bold text-[#1967a5] mb-4" data-id="element-4420">
        Automatic Wire EDM Rethreading
      </h2>
      <p className="text-gray-700 leading-relaxed" data-id="element-4421">
        All wire EDM units now come with an automatic wire rethreading system.
        This feature works exceptionally well with wire as small as 0.002 inches
        in diameter, but the larger the wire diameter, the better. A
        high-pressure stream of water guides the wire through the workpiece.
      </p>
      <p className="text-gray-700 leading-relaxed" data-id="element-4422">
        Automatic threading enhances unattended operation by making it possible
        to produce multiple openings or features within a part in a single
        setup. Cutting and rethreading of the wire are controlled by codes in
        the program. If the wire breaks accidentally, the machine senses the
        break, rethreads the wire and resumes cutting where the wire broke. If
        wire smaller than 0.004 inches is required, a fine wire kit is available
        as an option.
      </p>
    </div>;
}